import { render, staticRenderFns } from "./LocationsSupported.vue?vue&type=template&id=d9a922d6&scoped=true&"
import script from "./LocationsSupported.vue?vue&type=script&lang=ts&"
export * from "./LocationsSupported.vue?vue&type=script&lang=ts&"
import style0 from "./LocationsSupported.vue?vue&type=style&index=0&id=d9a922d6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a922d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
